<script lang="ts">
    import { Col } from "sveltestrap";
    import { LoaderStyle } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Spinners/Spinners.json"
</script>
<Col sm="12">
    <Card headerTitle={LoaderStyle} CardBodyprops="row">
      <div slot="contentbody" style="display: contents;">
        <Col sm="6" md="3" xs="12">
          <h6 class="sub-title mb-0 text-center">Loader 1</h6>
          <div class="loader-box">
            <div class="loader-1"></div>
          </div>
        </Col>
        {#each data.spinnersdata as spinnersItem}
          <Col sm="6" md="3" xs="12">
            <h6 class="sub-title mb-0 text-center">{spinnersItem.name}</h6>
            <div class="loader-box">
              <div class={spinnersItem.class}></div>
            </div>
          </Col>
        {/each}
      </div>
    </Card>
</Col>